<script lang='ts'>
import { reactive, defineComponent } from '@vue/composition-api';

const PublicIdeaPortal = defineComponent({
    name: 'PublicIdeaPortal',

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props, ctx) {
        const state = reactive({});

        return {
            state,
        };
    },
});

export default PublicIdeaPortal;
</script>

<template>
  <v-app>
    <v-main style="height: 100vh;">
      <!-- <AppPageLoader :isLoading="loading" delay="300">  -->
      <v-slide-y-transition mode="out-in">
        <router-view class="full-height" style="overflow-y: auto;" />
      </v-slide-y-transition>
      <!-- </AppPageLoader> -->
    </v-main>
    <AppSnackbar />
  </v-app>
</template>

<style lang='scss' scoped></style>